<template>
    <div>
        <footer class="has-text-centered">
            <button class="button is-primary is-large is-hidden-touch" @click.prevent="submitButton">SEARCH</button>
            <button class="button is-primary is-fullwidth is-large is-hidden-desktop" @click.prevent="submitButton">SEARCH</button>
        </footer>
    </div>
</template>

<script>
    export default {
        methods: {
            submitButton: function () {
                this.$router.push({ name: 'SearchResult' })
            }
        }
    }
</script>

<style scoped>
    footer {
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        z-index:1000;
    }
    footer .button {
        border-radius: 0;
        bottom: 20px
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/SubmitSearchButton.vue